import React from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";

interface AgeChangeChunkProps {
  change: ActivityChange;
}

export function AgeChangeChunk({ change }: AgeChangeChunkProps) {
  const nextStatus =
    typeof change.newValue === "string" ? change.newValue : change.newValue?.value;

  return (
    <Text size="sm">
      changed age
      {nextStatus ? (
        <Text size="sm">
          {" "}to <Text size="sm">{nextStatus}</Text>
        </Text>
      ) : null}
    </Text>
  );
}
